var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10925 2.33325C3.42325 2.33325 2.33325 3.48858 2.33325 5.27725V10.7226C2.33325 12.5113 3.42325 13.6666 5.10925 13.6666H10.8879C12.5759 13.6666 13.6666 12.5113 13.6666 10.7226V5.27725C13.6666 3.48858 12.5759 2.33325 10.8893 2.33325H5.10925ZM10.8879 14.6666H5.10925C2.85059 14.6666 1.33325 13.0813 1.33325 10.7226V5.27725C1.33325 2.91859 2.85059 1.33325 5.10925 1.33325H10.8893C13.1486 1.33325 14.6666 2.91859 14.6666 5.27725V10.7226C14.6666 13.0813 13.1486 14.6666 10.8879 14.6666ZM7.99592 11.1666C7.71992 11.1666 7.49592 10.9426 7.49592 10.6666V7.99992C7.49592 7.72392 7.71992 7.49992 7.99592 7.49992C8.27192 7.49992 8.49592 7.72392 8.49592 7.99992V10.6666C8.49592 10.9426 8.27192 11.1666 7.99592 11.1666ZM7.32919 5.46932C7.32919 5.83799 7.63052 6.13599 7.99919 6.13599C8.36785 6.13599 8.66585 5.83799 8.66585 5.46932C8.66585 5.10065 8.36785 4.80265 7.99919 4.80265H7.99252C7.62452 4.80265 7.32919 5.10065 7.32919 5.46932Z",
    fill: "#222326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquare);
export default __webpack_public_path__ + "static/media/info-square.bd03225c.svg";
export { ForwardRef as ReactComponent };